import analytics from '@/@core/utils/analytics'
import constants from '@/constants'

export const getSelectStorePlaceOrderModalEvents = {
  'change-stores': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CHANGES_STORE_SELECTION_IN_SELECT_STORE_PLACE_ORDER_MODAL,
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_SELECT_STORE_PLACE_ORDER_MODAL,
  confirm: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_SELECT_STORE_PLACE_ORDER_MODAL_CONFIRM_BTN,
}

export const getTermsModalEvents = {
  open: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_TERMS_CONDITIONS_LINK,
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_TERMS_CONDITIONS_MODAL,
  confirm: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_ACCEPTS_TERMS_CONDITIONS,
}

export const getExportCartModalEvents = {
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_EXPORT_CART_MODAL,
  'format-change': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CHANGES_EXPORT_TYPE,
  'download-click': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_DOWNLOAD_BUTTON,
  'view-export-cart-of-all-modal': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_VIEWS_EXPORT_CART_MODAL,
  'close-export-cart-of-all-modal': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_EXPORT_CART_ALL_STORES_MODAL,
  'change-stores': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CHANGES_SELECTION_STORES,
  'export-all-download-click': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_EXPORT_ALL_DOWNLOAD_MODAL,
}

export const getClearCartModalEvents = {
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_CLEAR_CART_MODAL,
  confirm: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_CLEAR_CART_CONFIRM_BUTTON,
  success: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLEAR_CART_SUCCESS,
  failed: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLEAR_CART_FAILED,
}

export const trackClearCartModal = (event, carts, additionalData = {}) => {
  analytics.track(getClearCartModalEvents[event], {
    carts,
    ...additionalData,
  })
}

export const trackExportCartModal = (event, carts, additionalData = {}) => {
  analytics.track(getExportCartModalEvents[event], {
    carts,
    ...additionalData,
  })
}

export const trackSelectStorePlaceOrderModal = (event, carts, selectedStoreIds) => {
  const data = {
    carts,
  }

  if (selectedStoreIds) {
    data.selectedStoreIds = selectedStoreIds
  }

  analytics.track(getSelectStorePlaceOrderModalEvents[event], data)
}

export const trackTermsModal = (event, carts, isChecked) => {
  analytics.track(getTermsModalEvents[event], {
    carts,
    isChecked,
  })
}

export const getRemoveProductEvents = {
  click: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_REMOVE_PRODUCT_ICON,
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_REMOVE_PRODUCT_MODAL,
  confirm: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_REMOVE_PRODUCT_CONFIRM_BUTTON,
  success: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_REMOVE_PRODUCT_SUCCESS,
  failed: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_REMOVE_PRODUCT_FAILED,
}

export const trackRemoveProduct = (event, cart, additionalData = {}) => {
  analytics.track(getRemoveProductEvents[event], {
    cart,
    ...additionalData,
  })
}

export const getCartEventTitles = {
  close: constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLOSES_VALIDATION_ERROR_MODAL,
  'btn-click': constants.TRACKS.ACTIONS.ORDER_DETAILS_PAGE.MULTIPLE_STORES.RETAILER_CLICKS_VALIDATION_ERROR_RESOLUTION_BUTTON,
}

export const trackCartErrorEvents = (event, carts, error) => {
  analytics.track(getCartEventTitles[event], {
    carts,
    error,
  })
}
